import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    borderRadius: '4px',
    height: 20,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 500,
    padding: '0 6px',
    '--designated-color': 'var(--color-colorPrimary-main)',
    border: '1px solid',
    borderColor: 'var(--designated-color)',
    color: 'var(--designated-color)',

    '&.color': {
      '&--primary': {
        '--designated-color': 'var(--color-colorPrimary-main)',
      },
      '&--danger': {
        '--designated-color': 'var(--color-error-tooltip)',
      },
      '&--warning': {
        '--designated-color': '#fd6900',
      },
    },
  },
}));

// color: 'primary', 'danger', 'warning'

const CountItem = ({ color = 'primary', count, className = '' }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.root} color--${color} ${className}`}>
      {count}
    </div>
  );
};

export default CountItem;
